<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>CREATE - ACCESS MANAGEMENT</h2>
       <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy</p>
       <a href="#" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>
       </div>
      </div>
       <form class="row">
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <select class="selectpicker form-control">
       <option selected="selected">User Name</option>
       <option value="Rama Chander">Rama Chander</option>
       <option value="Pandi">Pandi</option>
       </select>
       </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <select class="selectpicker form-control">
       <option selected="selected">User Role</option>
       <option value="University Officer">University Officer</option>
       <option value="University Officer">University Officer</option>
       </select>
       </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <select class="selectpicker form-control">
       <option selected="selected">Status</option>
       <option value="Active">Active</option>
       <option value="Inactive">Inactive</option>
       </select>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
       <div class="form-group">
       <label for="Description">Description</label>
       <textarea class="form-control" rows="5" placeholder="Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy Eirmod Tempor Invidunt Ut Labore Et Dolore Magna" id="comment"></textarea>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)="createaccessone()" class="btn btn-fill btn-primary mb-3">Next<div class="ripple-container"></div></button><br>
       <button type="submit" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
       </div>
       </form>
     </div>
   </div>
 </div>